var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisualMatrixPms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Visual_Matrix_PMS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual_Matrix_PMS",
    "data-name": "Visual Matrix PMS",
    clipPath: "url(#clip-Visual_Matrix_PMS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye_4878691",
    transform: "translate(-9.811 -9.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M31.652,70.654V86.7H24.268a7.382,7.382,0,1,0,0,4h9.384a2,2,0,0,0,2-2V72.47c1.925.81,3.922,1.568,6,2.234a26.926,26.926,0,0,1,0-40.04c-2.077.668-4.074,1.428-6,2.24V20.667a2,2,0,0,0-2-2H24.268a7.382,7.382,0,1,0,0,4h7.384V38.723A88.3,88.3,0,0,0,10.411,53.264a1.964,1.964,0,0,0-.6,1.42,2.044,2.044,0,0,0,.6,1.44,88.093,88.093,0,0,0,21.241,14.53ZM17.2,92.085A3.383,3.383,0,1,1,20.578,88.7,3.385,3.385,0,0,1,17.2,92.085Zm0-68.036a3.383,3.383,0,1,1,3.382-3.382A3.386,3.386,0,0,1,17.2,24.049Z",
    transform: "translate(0 4.993)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M54.717,22.665a7.382,7.382,0,1,0,0-4H45.334a2,2,0,0,0-2,2V36.9c-1.925-.812-3.923-1.573-6-2.241a26.926,26.926,0,0,1,0,40.04c2.078-.665,4.077-1.424,6-2.234V88.7a2,2,0,0,0,2,2h9.383a7.383,7.383,0,1,0,0-4H47.335V70.653A88.027,88.027,0,0,0,68.572,56.125a2.04,2.04,0,0,0,.6-1.442,1.96,1.96,0,0,0-.6-1.42,88.245,88.245,0,0,0-21.238-14.54V22.665h7.384Zm7.072-5.382a3.383,3.383,0,1,1-3.382,3.382,3.386,3.386,0,0,1,3.382-3.382Zm0,68.036A3.383,3.383,0,1,1,58.407,88.7,3.387,3.387,0,0,1,61.789,85.319Z",
    transform: "translate(40.638 4.994)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M43.855,35.291a4.85,4.85,0,0,1-.76.04,7.3,7.3,0,0,1-7.3-7.3,6.129,6.129,0,0,1,.16-1.482c-.262-.018-.522-.04-.782-.04a8.64,8.64,0,1,0,8.68,8.78Z",
    transform: "translate(24.635 24.526)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M66.84,59.677a23.044,23.044,0,0,0-21.078-22.9V24.359a7.384,7.384,0,1,0-4,0v12.42a22.977,22.977,0,0,0,0,45.8V95a7.382,7.382,0,1,0,4,0V82.576A23.044,23.044,0,0,0,66.84,59.677ZM40.378,17.287a3.383,3.383,0,1,1,3.384,3.382A3.387,3.387,0,0,1,40.378,17.287Zm-9.3,42.39A12.69,12.69,0,0,1,43.76,47.035a12.487,12.487,0,0,1,4.14.74,2.016,2.016,0,0,1,1.24,1.242,1.972,1.972,0,0,1-.22,1.74,3.219,3.219,0,0,0-.538,1.8,3.3,3.3,0,0,0,4.818,2.92,1.954,1.954,0,0,1,1.762-.06,2.02,2.02,0,0,1,1.118,1.358,12.665,12.665,0,1,1-25,2.9Zm16.064,42.394a3.383,3.383,0,1,1-3.382-3.386A3.386,3.386,0,0,1,47.144,102.072Z",
    transform: "translate(16.05 0)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualMatrixPms);
export default __webpack_public_path__ + "static/media/visual-matrix-PMS.7918c7c4dd05dd5b6d0eb9eb45663b67.svg";
export { ForwardRef as ReactComponent };